const styles = {
  container: {
    width: '100%',
    overflow: 'hidden'
  },

  titleContainer: {
    textAlign: 'center' as const,
    marginBottom: '20px'
  },

  title: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#666666',
    margin: '0',
    textTransform: 'uppercase' as const,
    letterSpacing: '1px'
  },

  marqueeContainer: {
    width: '100%',
    overflow: 'hidden',
    backgroundColor: 'transparent'
  },

  itemContainer: {
    textDecoration: 'none',
    marginRight: '90px'
  }
}

export default styles
